import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import type { AddressMapData } from "shared-ui/src/features/maps-feature/AddressMapProvider";
import { getAddressMap } from "../stores/mapsStore";

const CACHE_KEY_ADDRESS_MAP = "AddressMap";

interface UseGetAddressMapParams {
  latitude?: number | null;
  longitude?: number | null;
  width?: number;
  height?: number;
}

export const useGetAddressMap = ({
  latitude,
  longitude,
  width,
  height,
}: UseGetAddressMapParams) => {
  const hasCoordinates =
    latitude !== null && latitude !== undefined && longitude !== null && longitude !== undefined;

  return useQuery<AddressMapData, Error>({
    queryKey: [CACHE_KEY_ADDRESS_MAP, latitude, longitude, width, height],
    queryFn: () =>
      getAddressMap({
        latitude: latitude as number,
        longitude: longitude as number,
        width,
        height,
      }),
    enabled: hasCoordinates,
    staleTime: ms("5m"),
  });
};
